import { gql } from '@apollo/client';
import { ContentfulAsset } from '../types/contentfulAsset';
import performQuery from './contentfulClient';

export const ASSET_QUERY = gql`
  query assetQuery($id: String!) {
    asset(id: $id) {
      sys {
        id
      }
      title
      description
      contentType
      fileName
      size
      url
      width
      height
    }
  }
`;

export const useAssetQuery = async (id: string) => {
  const response = await performQuery(ASSET_QUERY, { id });

  if (response.hasError) {
    return {
      data: null,
      error: true,
      errorMsg: response.error,
    };
  }

  return {
    data: response.res?.data?.asset as ContentfulAsset | null,
    error: false,
  };
};
